import React from "react";
import styles from "./team.module.css";
import linkedinIcon from "./linkedin.png";

const Teamcard=({name,role,image,linkedin}) => {
    return (
        <a
        href={linkedin || "#"}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.cardLink}
        >
        <div className={styles.card}>
            {linkedin && (
                <a 
                href={linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.linkedinBadge}
                >
                    <img 
                    src={linkedinIcon}
                    alt="LinkedIn"
                    className={styles.linkedinImg}
                    ></img>
                </a>
            )}
            {image && <img src={image} alt={name} className={styles.cardImg} />}
            {name && <h3 className={styles.cardName}>{name}</h3>}
            {role && <p className={styles.cardRole}>{role}</p>}
        </div>
        </a>
    );
};

export default Teamcard;